<template>
  <b-card
    v-if="a && a.hasPermission('edit projects')"
    class="mb-2"
  >
    <b-row class="align-items-center">
      <b-col cols="auto">
        <b-button
          variant="outline-primary"
          class="d-flex align-items-center"
          v-b-tooltip.hover.top="config.tooltip"
          @click="toggleForm"
        >
          <feather-icon
            :icon="showForm ? 'ChevronUpIcon' : 'ChevronDownIcon'"
            size="16"
            class="mr-1"
          />
          <feather-icon
            icon="UsersIcon"
            size="16"
          />
        </b-button>
      </b-col>
      <b-col
        v-if="currentTeams.length > 0 && !showForm"
        class="text-muted small"
      >
        <span>الأعضاء الحاليون: </span>
        <span
          v-for="(team, index) in currentTeams"
          :key="team.id"
        >
          {{ team.full_name || team.name }}{{ index < currentTeams.length - 1 ? '، ' : '' }}
        </span>
      </b-col>
      <b-col
        v-if="showForm"
        cols="10"
      >
        <b-collapse v-model="showForm">
          <b-row>
            <b-col
              :sm="config.selectColSm"
              :md="config.selectColMd"
            >
              <validation-provider
                #default="{ errors }"
                :name="config.teamLabel"
                :vid="config.vid"
              >
                <b-form-group :label-for="config.vid">
                  <v-select
                    v-model="selectedTeams"
                    :options="a.employeeSelectOptions"
                    :reduce="a.employeeOptionReduce"
                    :get-option-label="a.employeeOptionLabel"
                    :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                    multiple
                    :close-on-select="false"
                    :disabled="isBusy"
                    :placeholder="config.placeholder"
                    @search="a.onEmployeeSearch"
                  >
                    <template #option="option">
                      <span class="ml-50"> {{ a.employeeOptionLabel(option) }}</span>
                    </template>
                    <template #selected-option="option">
                      <span class="ml-50"> {{ a.employeeOptionLabel(option) }}</span>
                    </template>
                  </v-select>
                </b-form-group>
                <small class="text-danger float-left">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              sm="4"
              md="2"
              class="d-flex align-items-end"
            >
              <b-button
                variant="primary"
                :disabled="isBusy"
                class="w-100"
                @click="save"
              >
                <b-spinner
                  v-if="isUpdating"
                  small
                  class="mr-1"
                />
                <span v-else>حفظ </span>
              </b-button>
            </b-col>
          </b-row>
        </b-collapse>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { ValidationProvider } from 'vee-validate'
import {
  VBTooltip, BFormGroup, BRow, BCol, BButton, BSpinner, BCard, BCollapse,
} from 'bootstrap-vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import vSelect from 'vue-select'
import { TEAM_EDITOR_CONFIG } from './teamEditorConfig'

export default {
  name: 'TeamEditorCard',
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  components: {
    BSpinner,
    BCard,
    BButton,
    ValidationProvider,
    BFormGroup,
    BRow,
    BCol,
    FeatherIcon,
    BCollapse,
    vSelect,
  },
  inject: {
    attachmentsRoot: { default: null },
  },
  props: {
    type: {
      type: String,
      required: true,
      validator: value => Object.prototype.hasOwnProperty.call(TEAM_EDITOR_CONFIG, value),
    },
  },
  computed: {
    a() {
      return this.attachmentsRoot
    },
    config() {
      return TEAM_EDITOR_CONFIG[this.type]
    },
    showForm: {
      get() {
        return Boolean(this.a && this.a[this.config.showFormKey])
      },
      set(value) {
        if (this.a) this.a[this.config.showFormKey] = value
      },
    },
    selectedTeams: {
      get() {
        return this.a ? this.a[this.config.teamsKey] : []
      },
      set(value) {
        if (this.a) this.a[this.config.teamsKey] = value
      },
    },
    currentTeams() {
      if (!this.a) return []
      const teams = this.a[this.config.currentTeamsKey]
      return Array.isArray(teams) ? teams : []
    },
    isBusy() {
      if (!this.a) return false
      return Boolean(this.a[this.config.updatingKey] || this.a[this.config.loadingKey])
    },
    isUpdating() {
      if (!this.a) return false
      return Boolean(this.a[this.config.updatingKey])
    },
  },
  methods: {
    toggleForm() {
      if (!this.showForm && this.a) {
        this.a.ensureEmployeesLoaded()
      }
      this.showForm = !this.showForm
    },
    save() {
      if (this.a && typeof this.a[this.config.updateMethod] === 'function') {
        this.a[this.config.updateMethod]()
      }
    },
  },
}
</script>
